
import React from "react";
import { Sticky } from 'react-sticky';
// import PropTypes from 'prop-types';
import "./top-bar.scss"


export class TopBar extends React.Component
{
	constructor(props)
  {
    super(props);
    this.bar = React.createRef()
	}
	
	componentDidMount ()
	{
		$(this.bar.current).foundation(); //eslint-disable-line no-undef
	}

	render()
	{
		
		return (
			<Sticky >
				{({style, isSticky, wasSticky, distanceFromTop, distanceFromBottom, calculatedHeight }) => (
					<div ref={this.bar} style={{...style, left:0}} className="top-bar-container">
						<div className={distanceFromTop<=-10?"top-bar is-stuck":"top-bar"} >
								{this.props.children}
						</div>
					</div>
				)}
			</Sticky>
		);
	}
}

export class FoundationTopBar extends React.Component
{

	componentDidMount ()
	{
		$(document).ready(()=>{ //eslint-disable-line no-undef
			$(this.refs["topBar"]).foundation(); //eslint-disable-line no-undef
		});
	}

	render()
	{

		return (
	 	<div ref="topBar" className="top-bar-container" data-sticky-container>
			<div  data-sticky data-options="marginTop: 0; stickyOn: small;" style={{marginTop: "0px", top: "0px", width:"100%"}} className="sticky top-bar" >
					{this.props.children}
			</div>
		</div>
		);
	}
}
export class FixedTopBar extends React.Component
{
	render()
	{

		return (
	 	<div ref="topBar" className="top-bar-container" data-sticky-container>
			<div  data-sticky data-options="marginTop: 0; stickyOn: small;" style={{marginTop: "0px", top: "0px", width:"100%"}} className="sticky top-bar is-stuck" >
					{this.props.children}
			</div>
		</div>
		);
	}
}